// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.7
//   protoc               v5.29.6
// source: org_key.proto

export const protobufPackage = 'compasspb';

export enum OrgKeyStatus {
  ORG_KEY_STATUS_UNSPECIFIED = 0,
  ORG_KEY_STATUS_ACTIVE = 1,
  ORG_KEY_STATUS_EXPIRED = 2,
}

export interface OrgKey {
  org_key_id?: string | undefined;
  organization_id?: string | undefined;
  name?: string | undefined;
  is_sandbox?: boolean | undefined;
  created_by?: string | undefined;
  created_at?: string | undefined;
  expires_at?: string | undefined;
  last_used_at?: string | undefined;
  status?: OrgKeyStatus | undefined;
}

export interface CreateOrgKeyRequest {
  organization_id?: string | undefined;
  name?: string | undefined;
  is_sandbox?: boolean | undefined;
  expires_at?: string | undefined;
}

export interface CreateOrgKeyResponse {
  org_key?: OrgKey | undefined;
  /** The API key. Shown once; never stored. */
  api_key?: string | undefined;
}

export interface ListOrgKeysRequest {
  organization_id?: string | undefined;
}

export interface ListOrgKeysResponse {
  org_keys?: OrgKey[] | undefined;
}

export interface RotateOrgKeyRequest {
  organization_id?: string | undefined;
  org_key_id?: string | undefined;
}

export interface RotateOrgKeyResponse {
  org_key?: OrgKey | undefined;
  /** The new API key. Shown once; never stored. */
  api_key?: string | undefined;
}

export interface DeleteOrgKeyRequest {
  organization_id?: string | undefined;
  org_key_id?: string | undefined;
}

export interface DeleteOrgKeyResponse {}

/**
 * OrgKeyService manages organization API keys. Each key is backed by its own
 * api_client user and service account. The key (a JWE) is returned only by
 * create and rotate, and is never stored. Org Admins and system admins only.
 */
export interface OrgKeyService {
  createOrgKey(request: CreateOrgKeyRequest): Promise<CreateOrgKeyResponse>;
  listOrgKeys(request: ListOrgKeysRequest): Promise<ListOrgKeysResponse>;
  rotateOrgKey(request: RotateOrgKeyRequest): Promise<RotateOrgKeyResponse>;
  deleteOrgKey(request: DeleteOrgKeyRequest): Promise<DeleteOrgKeyResponse>;
}
